// extracted by mini-css-extract-plugin
export var alignCenter = "_99-d";
export var bannerShown = "_99-6";
export var buttonContent = "_99-0";
export var cardList = "_99-1";
export var centerContent = "_99-2";
export var chevron = "_99-3";
export var closePanelButton = "_99-k";
export var conversationContextContainer = "_99-l";
export var conversationDetailContainer = "_99-4";
export var detailWrapper = "_99-7";
export var dropdownButton = "_99-e";
export var dropdownTitle = "_99-9";
export var fullHeight = "_99-5";
export var hidden = "_99-a";
export var icon = "_99-b";
export var mergeSuggestionWrapper = "_99-m";
export var panel = "_99-i";
export var portalButtonsWrapper = "_99-c";
export var right = "_99-j";
export var tableSummaryContainer = "_99-8";
export var tableSummaryHeader = "_99-g";
export var threeDotsButton = "_99-f";
export var wide = "_99-h";